export function getErrorMessageByActionType(payload: { password?: string }): string {
  if (payload.password) {
    return 'Your request was unsuccessful, please try again';
  }

  return '';
}
